// src/components/forms/FormGrid.js
// Grid 2-col responsivo para fields dentro de FormSection.

import React from 'react'
import { Box } from '@mui/material'

export default function FormGrid({ children, sx }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
        gap: 2,
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
